var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSave = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.826 13.811a.632.632 0 0 1-1.065.415L9.285 10.94a1.143 1.143 0 0 0-1.57 0l-3.476 3.286a.632.632 0 0 1-1.065-.415A83.197 83.197 0 0 1 3.12 2.955C3.19 1.768 4.184.857 5.372.857h6.256c1.188 0 2.182.911 2.252 2.098a83.19 83.19 0 0 1-.054 10.856Z",
  stroke: "#2563EB",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgSave;